import { ForgotPasswordForm } from "../components/auth/ForgotPasswordForm";
import logo from "../../assets/logo.png";

export function ForgotPasswordPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-brand-500 to-brand-800 p-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-xl p-8">
        <div className="text-center mb-8">
          <img src={logo} alt="RunLens" className="h-24 mx-auto" />
        </div>

        <ForgotPasswordForm />
      </div>
    </div>
  );
}
